import "./App.css";
import { AlertProvider } from "./contexts/AlertContext";
import { UserProvider } from "./contexts/UserContext";
import AppRoutes from "./routes/AppRoutes";

const App = () => {
  return (
    <div className="App">
      <AlertProvider>
        <UserProvider>
          <AppRoutes />
        </UserProvider>
      </AlertProvider>
    </div>
  );
};

export default App;
